import React, { useEffect } from "react";
import Header from "../Utils/Header/Header";
import AbsoluteBg from "../Utils/AbsoluteBg/AbsoluteBg";
import Footer from "../Utils/Footer/Footer";
import AccommodationForm from "../Utils/AccomodationForm/AccomodationForm";
import "./Travels.css";

const Travels = (props) => {
  useEffect(() => {}, []);

  return (
    <div className="component-container">
      <Header />

      <div className="abstract-screen-wrapper">
        <AbsoluteBg />

        <div className="abstract-content-container">
          <h1 className="travel-title">Nearby Hotels from the Venue</h1>

          <div className="hotel-grid">
            {/* Piccadilly */}
            <div className="hotel-card">
              <img src="/kingship.jpg" alt="Kingship by Kahlon" />
              <h2>Kingship by Kahlon</h2>
              <p className="hotel-distance">
                Distance from Venue: 2.1 kms <br /> (6 mins approx.)
              </p>

              <p className="hotel-price">Standard Room: ₹3,000 / night + 18% GST</p>
              <a href="https://maps.app.goo.gl/g4s77yM6i6NFVb1w6" target="_blank" rel="noreferrer" className="view-btn">
                View on Map
              </a>
            </div>

            <div className="hotel-card">
              <img src="/itc-1.png" alt="Fortune by Kahlon" />
              <h2>Fortune Select Ananda</h2>

              <p className="hotel-distance">
                Distance from Venue: 9.1 kms <br /> (20 mins approx.)
              </p>

              <p className="hotel-price">Standard Room: ₹7,500 / night + 18% GST</p>
              <a href="https://maps.app.goo.gl/LVM3n3wGeSFzCSsGA" target="_blank" rel="noreferrer" className="view-btn">
                View on Map
              </a>
            </div>

            {/* Lemon Tree */}
            <div className="hotel-card">
              <img src="/fairfield.jpg" alt="Fairfield By Marriot" />
              <h2>Fairfield by Marriott</h2>
              <p className="hotel-distance">
                Distance from Venue: 18.9 kms <br /> (28 mins approx.)
              </p>

              <p className="hotel-price">Standard Room: ₹9,000 / night + 18% GST</p>
              <a href="https://maps.app.goo.gl/vAp7VtWBunGNh6PP8" target="_blank" rel="noreferrer" className="view-btn">
                View on Map
              </a>
            </div>
          </div>
        </div>
      </div>

      <AccommodationForm propSlug="emiss-cvj-2026" />

      <Footer />
    </div>
  );
};

export default Travels;
